export const decryptTextFuc = (txtContent) => {
    var crypto = require("crypto");
    const algorithm = "aes256";
    const key = ")(*&^%$#@!";
    let decipher = crypto.Decipher(algorithm, key);
    const decryptedText =
      decipher.update(txtContent, "hex", "utf8") + decipher.final("utf8");
    return decryptedText;
  };
  
  export const encryptTextFuc = (txtContent) => {
    var crypto = require("crypto");
    const algorithm = "aes256";
    const key = ")(*&^%$#@!";
    let Cipher = crypto.Cipher(algorithm, key);
    const encryptedText =
    Cipher.update(txtContent, "utf8", "hex") + Cipher.final("hex");
    return encryptedText;
  };
  